/* eslint-disable react-hooks/exhaustive-deps */
import moment from "moment";
import { useEffect, useState } from "react";
import { getGeneralTermsByIdApi } from "../../services/_generalTerms";

interface Props {
  termId: string;
}

const ViewGeneralTerm: React.FC<Props> = ({ termId }) => {
  const [generalTerm, setGeneralTerm] = useState<any>({});

  useEffect(() => {
    if (termId) {
      setGeneralTerm({});
      getGeneralTermDetails();
    }
  }, [termId]);

  const getGeneralTermDetails = async () => {
    const result: any = await getGeneralTermsByIdApi(termId as string);
    if (result.isSuccess) {
      setGeneralTerm(result.data);
    }
  };

  return (
    <div
      className="modal fade"
      id="viewGeneralTerm"
      tabIndex={-1}
      // aria-hidden="true"
    >
      <div className="modal-dialog modal-simple modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-body pt-0 pb-0">
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
            <div className="text-center">
              <h4 className="mb-0">General Term Details</h4>
            </div>
            <div className="info-container">
              <div className="pb-4 border-bottom text-capitalize mb-4"></div>
              <ul className="list-unstyled mb-6">
                <li className="mb-2">
                  <span className="h6 me-1">Product:</span>
                  <span>{generalTerm.product?.name || "N/A"}</span>
                </li>
                <li className="mb-2">
                  <span className="h6 me-1">Term:</span>
                  <span>{generalTerm?.term || "N/A"}</span>
                </li>
                <li className="mb-2">
                  <span className="h6 me-1">Created At:</span>
                  <span>
                    {generalTerm?.created_at
                      ? moment(generalTerm?.created_at).format(
                          "YYYY-MM-DD HH:mm:ss"
                        )
                      : ""}
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ViewGeneralTerm;
